/**
 * BriqueChart만의 Option의 Default
 *   - Option 속성은 Chart Element의 briqueChartOption로 저장된다.
 *   - Option 속성을 개별 화면별로 다르게 설정하려면 newPlot() 호출시 oBriquechartOption를 지정하여 호출하면 된다.
 */
export default {
  /**
   * briqueChartOption은 Chart Element의 briqueChartOption로 저장된다.
   */
  briqueChartOption: {
    tooltip: {
      mode: 'hover' // 툴팁 모드, hover, click, none, BRIQUECHART_TOOLTIP_MODES의 첫번째 것이 Default이다.
    },
    legend: {
      position: 'bottom', // 범례 위치, Default값을 Bottom이나 Left로 하면 차트를 그린 후, react()를 해야 하기 때문에 느려질 수 있다.
      width: 100, // Chart가 그려지기전 Legend의 위치를 자동으로 지정하기 위해서 세팅함(이후 자동 세팅됨)
      height: 60// Chart가 그려지기전 Legend의 위치를 자동으로 지정하기 위해서 세팅함(이후 자동 세팅됨)
    },
    xaxis: {
      min: {
        rate: 0 // 0 ~ 1, 계산된 값을 layout.yaxis.range에 설정한다.
      },
      max: {
        rate: 0 // 0 ~ 1, 계산된 값을 layout.yaxis.range에 설정한다.
      },
      rangeslider: {
        seriesIndices: [] // 이 값을 지정하면 해당하는 Series만 Range View에 표시된다.
      }
    },
    yaxis: {
      min: {
        rate: 0.1 // 0 ~ 1, 계산된 값을 layout.yaxis.range에 설정한다.
      },
      max: {
        rate: 0.1 // 0 ~ 1, 계산된 값을 layout.yaxis.range에 설정한다.
      }
    },
    data: {
      samplingData: {
        totalCountForSamplingDataOnInit: 100000 // 백만건 이상이면 초기에 Data Sampling 적용
      },

      bar: {
        zeroBase: false // 바차트에서 0부터 시작 여부(Plotly는 무조건 0부터 시작한다.), 값이 음수이면 아래로 Bar가 그려진다.
      }
    },

    palette: {
      name: 'default'
    }
  }
}
